<template>

	<div class="bkf7 gameall_list">
		<el-container>
			<div class="inter">
				<el-row>
					<div class="filter_box">

						<div class="div1">
							<label>游戏:</label>
							<ul class="filter_ul">
								<li v-for="(item, index) in $store.state.gamelist" @click="gameChose(item.id)"
									:class="{ 'active': channel == item.id }" :key="item.id" :label="item.name">
									{{ item.name }}
								</li>
							</ul>
						</div>


						<div class="div1">
							<label>大区:</label>
							<ul class="filter_ul">
								<li v-for="item in daqu_list" @click="daquchange(item.value)"
									:class="{ 'active': daqu == item.value }" :key="item.value" :label="item.label">
									{{ item.label }}
								</li>
							</ul>
						</div>
						<div class="div1" v-show="server_show">
							<label>服务器:</label>
							<ul class="filter_ul">
								<li v-for="item in server_list" @click="fuwqichange(item.value)"
									:class="{ 'active': fuwuqi == item.value }" :key="item.value" :label="item.label">
									{{ item.label }}
								</li>
							</ul>
						</div>



						<div class="div1" v-if="filterlist.length > 0">
							<label>其他筛选</label>
							<div class="filter_qita">
								<div v-for="item in filterlist">
									<el-select collapse-tags class="select " v-model="filter[item.name]"
										:placeholder="'请选择' + item.title" multiple @change="filterchange">
										<el-option v-for="item2 in item.content" :key="item2.value" :label="item2.title"
											:value="item2.value">
										</el-option>
									</el-select>
								</div>
							</div>
						</div>
						<div class="div1">
							<label>能否租号</label>
							<div class="filter_qita zuhao" style="width: 1px;flex: 1;">

								<el-radio-group @input="changeZu" v-model="is_zu" fill="#fe6730"
									style="width: 100%;display: flex;align-items: center;">
									<el-radio label="0">不可租</el-radio>
									<el-radio label="1">可租</el-radio>
								</el-radio-group>
							</div>
						</div>


						<div class="div1">
							<label>价格:</label>
							<ul class="filter_ul">
								<li @click="priceChongzhi" :class="{ 'active': priceindex == -1 }">
									全部
								</li>
								<li v-for="(item, index) in pricelist" @click="priceChose(item,index)"
									:class="{ 'active': priceindex == index }" v-if="item.max != 9999999">
									{{ item.min }} - {{ item.max }}
								</li>
								<li v-for="(item, index) in pricelist" @click="priceChose(item,index)"
									:class="{ 'active': priceindex == index }" v-if="item.max == 9999999">
									{{ item.min }}以上
								</li>
							</ul>
						</div>


						<div class="div1">
							<label>价格区间</label>
							<div class="qujian">
								<el-input v-model="filter.strprice" @change="strpricechange" placeholder="最低值">
								</el-input>
								<span>—</span>
								<el-input v-model="filter.endprice" @change="endpricechange" placeholder="最高值">
								</el-input>
							</div>
						</div>
						<div class="div1" style="padding-top: 20px;">
							<label>账号类型</label>
							<div class="filter_qita zuhao" style="width: 1px;flex: 1;">


								<button class="acc_btn" @click="changeAcc(1)"
									:class="{'active':acc_type == 1}">官方自营</button>
								<button class="acc_btn" @click="changeAcc(2)"
									:class="{'active':acc_type == 2}">自由市场</button>

								<!-- 	<el-radio-group @input="changeAcc" v-model="acc_type" fill="#fe6730"
									style="width: 100%;display: flex;align-items: center;">
									<el-radio label="1">官方自营</el-radio>
									<el-radio label="2">自由市场</el-radio>
								</el-radio-group> -->
							</div>
						</div>

					</div>
				</el-row>

				<el-row>
					<div class="sortpaixu">
						<ul class="sortpaixu_ul">
							<li :class="{ 'active': sortactive == 1 }" @click="chose_sort(1)"><span>默认排序</span></li>
							<li :class="{ 'active': sortactive == 2 }" @click="chose_sort(2, sort_time)">
								<span>发布时间</span><span v-if="sortactive == 2 && sort_time == 0">↑</span><span
									v-if="sortactive == 2 && sort_time == 1">↓</span>
							</li>
							<li :class="{ 'active': sortactive == 3 }" @click="chose_sort(3, sort_price)">
								<span>价格</span><span v-if="sortactive == 3 && sort_price == 0">↑</span><span
									v-if="sortactive == 3 && sort_price == 1">↓</span>
							</li>
						</ul>


					</div>
				</el-row>
				<div class="zh_wcontent">


					<el-row>


						<div v-show="loading" style="padding: 20px;" v-loading="loading" element-loading-text="加载中"
							element-loading-spinner="el-icon-loading">
							<el-skeleton :rows="6" animated />
						</div>


						<ul class="zh_list">


							<li v-for="item in flowList" v-show="!loading">
								<!-- <a :href="'/pages/game/index/channel?id='+item.id"> -->


								<router-link :title="item.title" target="_blank"
									:to="{ path: 'goodsdetail', query: { id: item.id } }">
									<div class="image">
										<el-image :src="item.image" lazy></el-image>
									</div>
									<div class="text">
										<p class="p1">{{ item.title }}</p>
										<p class="p2 f14">上架时间:{{ item.updatetime }}</p>
										<p class="p3 f14"> <i class="el-icon-view"></i> {{ item.views }}</p>
										<div>
											<span class="price text-F7423F">￥{{ item.price }}</span>

											<div style="display: inline-block;margin-left: 30px;"
												v-if="item.is_zu == 1">

												租号价格:
												<span class="text-F7423F">{{ item.zuhao_price }}</span>
											</div>

										</div>
										<div class="text2 t-flex t-flex-items-center">
											<div class="t-flex t-flex-items-center">
												<p v-for="(item1, index1) in item.bq_text" v-if="item1 != '找回包赔'">
													<el-tag effect="dark" v-if="item1 == '官方自营'">
														{{ item1 }}
													</el-tag>
													<el-tag effect="dark" v-if="item1 == '官方代售'">
														{{ item1 }}
													</el-tag>
												</p>

												<p v-for="(item1, index1) in item.bq_text" v-if="item1 == '找回包赔'">
													<el-tag effect="blue" v-if="item1 == '找回包赔'">
														{{ item1 }}
													</el-tag>
												</p>


												<p v-if="item.is_zu == 1">
													<el-tag effect="dark">
														可租
													</el-tag>
												</p>
											</div>
										</div>

									</div>

								</router-link>
								<!-- </a> -->
							</li>
						</ul>


						<el-pagination class="pagebox" background @size-change="handleSizeChange"
							@current-change="handleCurrentChange" :current-page="current_page"
							:page-sizes="[10, 20, 30, 40, 50]" :page-size="10"
							layout="total, sizes, prev, pager, next, jumper" :total="total">
						</el-pagination>

					</el-row>
				</div>
			</div>
		</el-container>
	</div>

</template>
<script>
	export default {
		data() {
			return {
				query: [],
				daqu_list: [],
				server_list: [],
				server_show: false,
				channel: 0,
				daqu: 0,
				fuwuqi: 0,
				order: 1,
				flowList: [],
				filterlist: [],
				fbeifen: [],
				channeldata: [],
				current_page: 1,
				pagesize: 10,
				total: 0,
				last_page: 0,
				filter: {
					strprice: '',
					endprice: '',
				},
				loadStatus: 'loadmore',
				strprice: '',
				endprice: '',
				key: '',
				sortactive: 1,
				sort_time: 0,
				sort_price: 0,
				is_zu: 0,
				acc_type: "1",
				loading: true,
				priceindex: -1,
				pricelist: [{
						min: 500,
						max: 4999
					},
					{
						min: 5000,
						max: 9999
					},
					{
						min: 10000,
						max: 14999
					},
					{
						min: 15000,
						max: 19999
					},
					{
						min: 20000,
						max: 9999999
					}
				]
			}
		},
		created: function(data) {

			this.daqu_list = this.$data.options2;
			this.value = this.$route.query.gtype;
			this.value2 = this.$route.query.region;
			this.value3 = this.$route.query.server;
			this.key = this.$route.query.keyword;
			this.channel = this.$route.query.gtype;
			this.daqu = this.$route.query.region;
			this.fuwuqi = this.$route.query.server;
			this.is_zu = this.$route.query.is_zu;
			this.getDaqu(this.$data.channel);
			this.addRandomData(this.$data.channel, this.$data.current_page);
			if (this.$data.daqu != 0) {
				this.getFuwuqi(this.$data.daqu);
			}

		},
		watch: {
			$route() {
				this.$data.daqu_list = this.$data.options2;
				this.$data.value = this.$route.query.gtype;
				this.$data.value2 = this.$route.query.region;
				this.$data.value3 = this.$route.query.server;
				this.$data.key = this.$route.query.keyword;
				this.$data.channel = this.$route.query.gtype;
				this.$data.daqu = this.$route.query.region;
				this.$data.fuwuqi = this.$route.query.server;
				this.getDaqu(this.$data.channel);
				this.$data.current_page = 1;
				this.$data.pagesize = 10;
				this.addRandomData(this.$data.channel, this.$data.current_page);
				if (this.$data.daqu != 0) {
					this.getFuwuqi(this.$data.daqu);
				}
			}
		},
		methods: {
			priceChose(item,index) {
				this.filter.strprice = item.min
				this.filter.endprice = item.max
				this.priceindex = index
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.total);
			},
			priceChongzhi() {
				this.filter.strprice = ''
				this.filter.endprice = ''
				this.priceindex = -1
				this.current_page = 1;
				this.addRandomData(this.channel, this.current_page, this.total);
			},
			gameChose(id) {
				this.channel = id;
				this.daqu = 0;
				this.fuwuqi = 0;
				this.current_page = 1;
				
				this.filter.strprice = ''
				this.filter.endprice = ''
				this.priceindex = -1
				
				
				this.getDaqu(this.channel);
				this.addRandomData(this.channel, this.current_page, this.total);
			},
			changeZu(e) {
				this.$data.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
			},
			changeAcc(e) {
				this.acc_type = e
				this.current_page = 1;
				this.addRandomData(this.$data.channel, this.current_page, this.$data.total);
			},
			chose_sort(index, name) {
				this.$data.sortactive = index;

				switch (index) {
					case 1:
						this.$data.order = 1;
						this.$data.sort_time = 0;
						this.$data.sort_price = 0;
						break;
					case 2:
						this.$data.sort_price = 0;
						if (name == 0) {
							this.$data.sort_time = 1;
							this.$data.order = 1;
						} else {
							this.$data.sort_time = 0;
							this.$data.order = 2;
						}
						break;
					case 3:
						this.$data.sort_time = 0;
						if (name == 0) {
							this.$data.sort_price = 1;
							this.$data.order = 4;
						} else {
							this.$data.sort_price = 0;
							this.$data.order = 3;
						}
						break;
				}



				this.$data.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);


			},
			//其他筛选变更
			filterchange() {
				this.addRandomData(this.$data.channel, this.$data.current_page);
			},
			getDaqu(id) {
				this.rq.requests.post("/api/Hall/getDaqu", {
					id: id,

				}).then(res => {

					if (res.data.length >= 1) {
						this.$data.daqu_list = res.data;
					} else {
						this.$data.daqu_list = [];
						val.value = '0';
						val.label = '全部';
						val.disabled = true;
						this.$data.daqu_list.push(val)
					}
				}).catch(error => {

				})
			},
			getFuwuqi(id) {
				this.rq.requests.post("/api/Hall/getFuwqi", {
					id: id,

				}).then(res => {

					if (res.data.length >= 1) {
						this.$data.server_list = res.data;
						this.$data.server_show = true;
					} else {
						this.$data.server_list = [];

					}
				}).catch(error => {

				})
			},

			getFuwuqi(id) {
				this.rq.requests.post("/api/Hall/getFuwqi", {
					id: id,

				}).then(res => {

					if (res.data.length >= 1) {
						this.$data.server_list = res.data;
						this.$data.server_show = true;
					} else {
						this.$data.server_list = [];

					}
				}).catch(error => {

				})
			},

			addRandomData(id, current_page, pagesize) {
				this.loading = true;
				var that = this;
				var filter = {};
				filter = this.$data.filter;
				filter.daqu = this.$data.daqu;
				filter.fuwuqi = this.$data.fuwuqi;
				filter.q = this.$data.key;
				filter = JSON.stringify(filter);
				filter = encodeURIComponent(filter);



				this.rq.requests.post("api/hall/getCarchives", {
					id: id,
					page: current_page,
					filter: filter,
					order: that.$data.order,
					is_zu: that.$data.is_zu,
					acc_type: that.acc_type,
					pagesize: that.pagesize,
				}).then(res => {
					that.$data.last_page = res.data.last_page;
					sessionStorage.setItem('filterlist', res.data.filterlist);
					sessionStorage.setItem('filter', res.data.filter);

					that.$data.filterlist = res.data.filterlist;
					that.$data.channeldata = res.data.channeldata;

					that.$data.filter = res.data.filter;
					that.$data.strprice = res.data.filter.strprice;
					that.$data.endprice = res.data.filter.endprice;
					that.$data.current_page = res.data.current_page;
					that.$data.total = res.data.total;

					that.$data.flowList = res.data.data;
					that.loading = false

				}).catch(error => {

				})
			},

			handleSizeChange(val) {

				this.pagesize = val;
				this.addRandomData(this.$data.channel, this.$data.current_page, val);
			},
			handleCurrentChange(val) {
				this.current_page = val;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
			},
			strpricechange() {

				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
			},
			endpricechange() {
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
			},
			//选择大区
			daquchange(value) {
				this.$data.daqu = value;
				this.$data.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
				if (value != 0) {
					this.getFuwuqi(value);
				}

			},
			//选择服务器
			fuwqichange(value) {
				this.$data.fuwuqi = value;
				this.$data.current_page = 1;
				this.addRandomData(this.$data.channel, this.$data.current_page, this.$data.total);
			}

		}
	}
</script>
<style>
	.zuhao .el-radio__input {
		display: flex !important;
		align-items: center;
	}

	.zuhao .el-radio__input.is-checked .el-radio__inner {
		border-color: #fe6730;
		background: #fe6730;
	}

	.zuhao .el-radio__input.is-checked+.el-radio__label {
		color: #fe6730;
	}
</style>